
import Button from '@/components/buttons/Button.vue';
import { ButtonSize, buttonSizes } from '@/lib/enum/ButtonSizes';
import {
  ActiveTabStyleEnum,
  ActiveTabStyleType,
  TPageTab,
} from '@/types/propTypes';
import { PropType } from 'vue';

export default {
  name: 'PageTabs',
  components: {
    Button,
  },
  props: {
    tabs: {
      type: Array as PropType<TPageTab[]>,
      required: true,
    },
    activeTabStyle: {
      type: String as PropType<ActiveTabStyleType>,
      default: ActiveTabStyleEnum.Solid,
    },
    tabButtonSize: {
      type: String as PropType<ButtonSize>,
      default: 'md',
      validator: (p) => buttonSizes.includes(p),
    },
  },

  computed: {
    activeTabStyleWithUnderline(): boolean {
      return this.activeTabStyle === ActiveTabStyleEnum.Underline;
    },
  },
};
